import React, { Fragment } from "react";
import { Badge, Loader, Modal, Pagination, Thumbnail } from "@culturehq/components";

import { ProfileLink } from "app/links";
import { Trans } from "app/utils";
import getUserName from "app/utils/getUserName";
import ChqModal from "./ChqModal";

const MentionHeaderGroup = ({ group, prefix, icon }) => {
  if (group.length === 0) {
    return null;
  }

  return (
    <>
      {prefix}
      {" "}
      {group.map(({ entityId, userId, name }) => (
        <Fragment key={entityId || userId}>
          <Badge primary icon={icon}>{name}</Badge>
          {" "}
        </Fragment>
      ))}
    </>
  );
};

const MentionHeader = ({ mentions, totalCount }) => {
  const groups = {
    departments: [],
    interests: [],
    locations: [],
    organizations: [],
    skills: [],
    users: []
  };

  mentions.forEach(mention => groups[mention.type || "users"]?.push(mention));

  const { departments, interests, locations, organizations, skills, users } = groups;
  const entityCount = locations.length + departments.length + interests.length;
  const emptyField = field => groups[field].length === 0;

  const getPrefix = (previousData, nextData, prefix) => {
    const BreakException = {};
    try {
      previousData.forEach(previous => {
        if (!emptyField(previous)) {
          throw BreakException;
        }
      });
    } catch (_) {
      try {
        nextData.forEach(next => {
          if (!emptyField(next)) {
            throw BreakException;
          }
        });
        return `${prefix}`;
      } catch (_) {
        return prefix;
      }
    }

    return prefix;
  };

  return (
    <div className="chq-mention-list--hd">
      {totalCount} {totalCount === 1 ? "person " : "people "}
      {organizations.length === 0 && entityCount > 0 && (
        <>
          <MentionHeaderGroup group={locations} prefix="in" icon="loc-ol" />
          <MentionHeaderGroup group={departments} prefix={getPrefix(["locations"], ["interests", "skills"], "in")} icon="diagram" />
          <MentionHeaderGroup group={interests} prefix={getPrefix(["locations", "departments"], ["skills"], "interested in")} icon="heart-ol" />
          <MentionHeaderGroup group={skills} prefix={getPrefix(["locations", "departments", "interests"], [], "skilled in")} icon="hammer" />
          <MentionHeaderGroup group={users} prefix="as well as" icon="person" />
        </>
      )}
    </div>
  );
};
const UsersModal = ({ children, users, pagination, loading, fetchUsers, mentions, title }) => {
  const totalCount = pagination.totalCount || 0;
  return (
    <ChqModal
      entrance="zoomIn"
      trigger={children}
      ariaLabelledBy="users-title"
      ariaDescribedby="users-title"
    >
      <Modal.Heading>
        <h2 id="users-title"><Trans>{title}</Trans></h2>
      </Modal.Heading>
      <Modal.Body>
        <Loader loading={loading}>
          {mentions && <MentionHeader mentions={mentions} totalCount={totalCount} />}
          <div className="chq-mention-list">
            {users.map(user => (
              <ProfileLink key={user.id} user={user}>
                <Thumbnail image={user.avatar.thumbUrl} />
                {getUserName(user)}
                <br />
                <small>{user.title}</small>
              </ProfileLink>
            ))}
          </div>
          <Pagination {...pagination} onClick={fetchUsers} />
        </Loader>
      </Modal.Body>
    </ChqModal>
  );
};

export default UsersModal;
